var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9228 10.9954C16.792 10.3479 16.5365 9.74493 16.1823 9.21288L17.2959 7.40729L16.9366 7.04799L16.5773 6.68868L14.7718 7.80223C14.2398 7.44813 13.6369 7.19256 12.9892 7.06181L12.5005 5H11.9923H11.4842L10.9954 7.06181C10.3477 7.19257 9.74483 7.44815 9.21285 7.80223L7.40732 6.68868L7.048 7.04799L6.68869 7.40729L7.80227 9.21288C7.44816 9.74492 7.1926 10.3478 7.06185 10.9954L5 11.4842V11.9923V12.5004L7.06176 12.9892C7.19245 13.637 7.44797 14.24 7.80204 14.7721L6.68869 16.5773L7.048 16.9366L7.40732 17.2959L9.21255 16.1826C9.74461 16.5367 10.3476 16.7922 10.9954 16.9229L11.4842 18.9846H11.9923H12.5005L12.9892 16.9229C13.637 16.7921 14.24 16.5366 14.7721 16.1826L16.5773 17.2959L16.9366 16.9366L17.2959 16.5773L16.1826 14.7721C16.5366 14.24 16.7921 13.637 16.9229 12.9892L18.9846 12.5004V11.9923V11.4842L16.9228 10.9954ZM11.9923 14.9081C10.3842 14.9081 9.07648 13.6004 9.07648 11.9923C9.07648 10.3851 10.3842 9.07647 11.9923 9.07647C13.6004 9.07647 14.9081 10.3851 14.9081 11.9923C14.9081 13.6004 13.6004 14.9081 11.9923 14.9081Z",
    fill: "#BCBEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.97906623a1c3927def52014990084922.svg";
export { ForwardRef as ReactComponent };